import { inject as h, ref as b, computed as t, unref as n } from "vue";
import { collapseContextKey as I } from "./index614.js";
import { useIdInjection as k } from "./index640.js";
import { useNamespace as C } from "./index559.js";
const j = (a) => {
  const s = h(I), { namespace: c } = C("collapse"), o = b(!1), e = b(!1), u = k(), d = t(() => u.current++), i = t(() => {
    var l;
    return (l = a.name) != null ? l : `${c.value}-id-${u.prefix}-${n(d)}`;
  }), m = t(
    () => s?.activeNames.value.includes(n(i))
  );
  return {
    focusing: o,
    id: d,
    isActive: m,
    handleFocus: () => {
      setTimeout(() => {
        e.value ? e.value = !1 : o.value = !0;
      }, 50);
    },
    handleHeaderClick: (l) => {
      if (a.disabled) return;
      const r = l.target;
      r?.closest("input, textarea, select") || (s?.handleItemClick(n(i)), o.value = !1, e.value = !0);
    },
    handleEnterClick: (l) => {
      const r = l.target;
      r?.closest("input, textarea, select") || (l.preventDefault(), s?.handleItemClick(n(i)));
    }
  };
}, w = (a, { focusing: s, isActive: c, id: o }) => {
  const e = C("collapse"), u = t(() => [
    e.b("item"),
    e.is("active", n(c)),
    e.is("disabled", a.disabled)
  ]), d = t(() => [
    e.be("item", "header"),
    e.is("active", n(c)),
    { focusing: n(s) && !a.disabled }
  ]), i = t(() => [
    e.be("item", "arrow"),
    e.is("active", n(c))
  ]), m = t(() => [e.be("item", "title")]), p = t(() => e.be("item", "wrap")), f = t(() => e.be("item", "content")), v = t(() => e.b(`content-${n(o)}`)), l = t(() => e.b(`head-${n(o)}`));
  return {
    itemTitleKls: m,
    arrowKls: i,
    headKls: d,
    rootKls: u,
    itemWrapperKls: p,
    itemContentKls: f,
    scopedContentId: v,
    scopedHeadId: l
  };
};
export {
  j as useCollapseItem,
  w as useCollapseItemDOM
};
